import { Button } from "@devhop/ui";
import { HelpCircleIcon, PlusIcon } from "lucide-react";

type ProvincesToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function ProvincesToolbar({
  canManage,
  onCreate,
  onStartTour,
}: ProvincesToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            ແຂວງ{" "}
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onStartTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            )}
          </h2>
          <p className="text-muted-foreground">ລາຍການແຂວງ, ເປີດ/ປິດການສະແດງ.</p>
        </div>
        <div
          className="flex items-center gap-2"
          data-tourid="geo-provinces-toolbar"
        >
          {canManage && (
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງແຂວງ
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
